import { EledoButton, EledoConnectionSelect, EledoModal, EledoStructureSelect } from 'components/library'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

export type EledoConnectForm = {
  connectionId: string
  structureId: string
}


const EledoConnectModal = ({connectionId, structureId, modalDisplayed, onSuccess, onDismiss}: {connectionId: string, structureId: string, modalDisplayed: boolean, onSuccess: (data: EledoConnectForm) => void, onDismiss: Function}) => {

  const formHandler = useForm<EledoConnectForm>({values: {connectionId, structureId}})
  const formValues = formHandler.watch()

  const modalContent = (
    <FormProvider {...formHandler}>
      <form>
        <EledoConnectionSelect id="connectionId" label="Select Connection" path="" defaultValue=""/>
        { formValues.connectionId &&
          <EledoStructureSelect id="structureId" label="Select Data Source" path="" defaultValue="" connectionId={formValues.connectionId} />
        }
      </form>
    </FormProvider>
  )
  
  const modalActions = (
    <>
      <EledoButton label={'OK'} primary grow icon="checkmark"
        onClick={formHandler.handleSubmit(data => onSuccess(data), data => console.log("invalid", data))} />
    </>
    )

  return (
    <EledoModal title={"Import Data Structure"}
                          content={modalContent}
                          actions={modalActions}
                          displayed={modalDisplayed}
                          onDismiss={() => onDismiss()}/>
  )
}

export default EledoConnectModal